import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AuthGuardService as AuthGuard
} from '@app/extra-module/auth-intercept/auth-guard.service';
import { InventoryDashboardComponent } from './inventory-dashboard/inventory-dashboard.component';
import { MainLayoutComponent } from '@app/shared-module/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: 'inventory', component: MainLayoutComponent, canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: InventoryDashboardComponent, canActivate: [AuthGuard], data: { title: 'Inventory Dashboard', enableExtraHeader: false } },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InventoryRoutingModule { }
